import { render } from "./ViewPage.vue?vue&type=template&id=64673cb4&scoped=true"
import script from "./ViewPage.vue?vue&type=script&lang=js"
export * from "./ViewPage.vue?vue&type=script&lang=js"

import "./ViewPage.vue?vue&type=style&index=0&id=64673cb4&scoped=true&lang=css"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64673cb4"]])

export default __exports__